import { useState, useEffect, useCallback } from 'react';
import { Deck } from '../types';
import { deckService } from '../services/deckService';
import { useAuth } from '../context/AuthContext';
import { usePolling } from './usePolling';

export const useDeckDetail = (deckId: string) => {
  const { token } = useAuth();
  const [deck, setDeck] = useState<Deck | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchDeck = useCallback(async () => {
    if (!token || !deckId) return;

    try {
      const deck = await deckService.getDeck(deckId, token);
      setDeck(deck); // getDeck now returns Deck directly
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [deckId, token]);

  // Initial fetch
  useEffect(() => {
    fetchDeck();
  }, [fetchDeck]);

  // Poll if still processing
  const shouldPoll = deck?.status === 'processing' || deck?.status === 'converting';
  usePolling(fetchDeck, 3000, shouldPoll);

  return { deck, loading, error, refresh: fetchDeck };
};

